// Maya MCP server endpoint. Single source of truth for the URL surfaced across the
// onboarding guide, the Shopify post-purchase page, and (mirrored) the completion email.
export const MCP_SERVER_URL = 'https://mcp.mayainsights.com/mcp'

// Public MCP documentation. The endpoint, OAuth shape and tool contract.
// Was .../mcp, which 404'd: the docs site had not deployed since 2023, and
// even after the rebuild only the trailing-slash form resolves. This path is
// a real page.
export const MCP_DOCS_URL = 'https://docs.mayainsights.com/docs/mcp-reference/'

// localStorage flag set the first time the user copies the MCP URL. The Data & Insights
// flow reads it to mark the "Ask Maya" step as done; a same-session copy also fires the
// MCP_URL_COPIED_EVENT window event so an already-mounted flow updates immediately.
// The key is namespaced per organization so one org's copy doesn't complete the step
// for every org on the device; the unscoped form is the fallback when no org is known.
export const MCP_URL_COPIED_KEY = 'maya_mcp_url_copied'
export const MCP_URL_COPIED_EVENT = 'maya-mcp-url-copied'

export const mcpUrlCopiedKey = (organizationId?: number): string =>
  organizationId ? `${MCP_URL_COPIED_KEY}:${organizationId}` : MCP_URL_COPIED_KEY
